import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AbstractPage } from  '../../../_com/abstract-page';
import { ReserveAction } from '../../../../actions/reserve.action';
import { ReserveDetailPage } from '../../detail/reserve-detail';
import { CompReserveListState } from '../../../../states/comp-reserve-list-state';
import { HttpReserveProvider } from '../../../../providers/http-reserve';

/**
 * Generated class for the ReserveListBasicPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@Component({
  selector: 'page-reserve-list-basic',
  templateUrl: 'reserve-list-basic.html',
})
export class ReserveListBasicPage extends AbstractPage{

  data = [];
  onChangeDate = null;
  onSaveReserve = null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private reserveAction:ReserveAction,
    private compReserveListState:CompReserveListState,
    private httpReserveProvider:HttpReserveProvider,
  	) {
    super();
    this.refresh();

    /**
     * 表示日付切り替えイベント
     */
    this.onChangeDate = this.compReserveListState.onChangeDate.subscribe((data)=>{
      this.refresh();
    });

    /**
     * 予約情報更新イベント
     */
    this.onSaveReserve = this.httpReserveProvider.onSaveReserve.subscribe((data)=>{
      this.refresh();
    });
  }

  /**
   * 一覧データ取得
   */
  refresh(){

    this.reserveAction.getList({date:this.compReserveListState.date, isValidOnly:false}).subscribe((res)=>{
      this.data = res.data;
    });
  }

  goDetail(data){

    this.navCtrl.push(ReserveDetailPage, data);
  }

  getType(family){

    switch (family["type"]) {
      case "spot":
        return "スポット";
      case "month":
        return "月極";
      case "ticket":
        return "チケット";
      case "benefit":
        return "ベネフィット";
      case "ticketbenefit":
        return "チケ+ベネフィット";
      case "shiki":
        return "劇団四季";
      case "reginaclinic":
        return "レジーナクリニック";
      case "shinagawa_kinshi":
        return "品川近視";
      case "meieki_shika":
        return "名駅歯科";
      case "asada":
        return "浅田LC";
      case "menkai_koryu":
        return "面会交流";
      case "futagohoiku":
        return "ふたごほいく";
      case "hitorioyashien":
        return "ひとり親家庭支援";
      case "100minus":
        return "100円引/時";
      case "fukuri":
        return "福利厚生";
      case "ato":
        return "後請求";
      // 以降削除済みだが、過去登録データは見えるように表示は残しておく
      case "time":
        return "タイムチケット";
      case "ha":
        return "ヒューマンアカデミー";
      default:
        return "区分/未登録";
    }
  }

  getAllergy(child){
    return (child["data"]["Child"]["allergy_status"] == "true") ? "アレルギー有り" : "";
  }

  getMisyoku(child){

    // return (super.getFoodNames(child["data"]["Child"]["tabetakotoaru_foods"], true) != "-" ? "未食あり" : "");

    switch (super.getFoodNames(child["data"]["Child"]["tabetakotoaru_foods"], true)) {
      case "-":
      case "":
        return "";
      default:
        return "未食あり";
    }
  }

  getKeijyoYasai(child){
    var y = child["data"]["Child"]["keijyo_yasai"];
    switch (y) {
      case "3":
        return "後期";
      case "4":
        return "中期";
      case "5":
        return "初期";
      default:
        return "";
    }
  }

  /**
   * コンポーネント離脱
   */
  ngOnDestroy(){
    this.onChangeDate.unsubscribe();
    this.onSaveReserve.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/pages/reserve/list/basic/reserve-list-basic.ts